export default "__VITE_ASSET__Dp2Cq0ly__"